module.exports = {
      id: "calculator-usage",
      viewBox: "0 0 24 34",
      url: __webpack_public_path__ + "img/icons.209f7259.svg#calculator-usage",
      toString: function () {
        return this.url;
      }
    }